export default __webpack_public_path__ + "static/Blue-Globe-df8a9058b2fcd32287ca1b8241c900d7.png";